import { addPendoScript } from 'components/App/hooks/pendoScript';
import { IS_DEV, IS_E2E, IS_STORYBOOK, IS_TEST } from 'env';
import { useEffect } from 'react';

const SHOULD_NOT_ADD_TRACKER = IS_E2E || IS_TEST || IS_DEV || IS_STORYBOOK;
export const useAddHubspot = () => {
    useEffect(() => {
        if (SHOULD_NOT_ADD_TRACKER) return;
        const scripTag = document.createElement('script');
        scripTag.id = 'hs-script-loader';
        scripTag.src = '//js.hs-scripts.com/6786528.js';
        document.body.appendChild(scripTag);
    }, []);
};

export const useAddPendo = () => {
    const IS_PDF = window.location.pathname.endsWith('/pdf');
    useEffect(() => {
        if (SHOULD_NOT_ADD_TRACKER || IS_PDF) return;
        // moved to a separate TS file to exclude TS and ESLint errors.
        addPendoScript('4f42ee7e-286d-42eb-71d0-5d041cb47c73');
    }, []);
};
